import { render, staticRenderFns } from "./Positionen.vue?vue&type=template&id=fe58972a"
import script from "./Positionen.vue?vue&type=script&lang=js"
export * from "./Positionen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports